import { investorsContentKz } from './investorsContent';

/** UI-строки — қазақша */
export const uiKz = {
  common: {
    menu: 'Мәзір',
    close: 'Жабу',
    back: 'Артқа',
    forward: 'Алға',
  },
  brand: {
    name: 'Қаржы орталығы',
    descriptor: 'Мемлекеттік бағдарламаларды қаржыландыру интеграторы',
    alt: 'Қаржы орталығы',
  },
  about: {
    missionTitle: 'Біздің миссия',
    missionText:
      'Мемлекеттік бағдарламаларды нәтижеге бағытталған тиімді қаржыландыруды қамтамасыз ету: деректер мен ашық ережелерге негізделген цифрлық, нормативтік және аналитикалық бөлу механизмдерін әзірлеу және сүйемелдеу.',
    cards: [
      { title: 'Жүйелілік', text: 'Жеке шешімдер емес, тұтас архитектура құрамыз' },
      { title: 'Ашықтық', text: 'Ережелер мен параметрлер баршаға түсінікті болуы тиіс' },
      { title: 'Тұрақтылық', text: 'Масштабталатын және ұзақ мерзімді механизмдер' },
      { title: 'Деректер', text: 'Есептеу мен аналитикаға негізделген шешімдер' },
    ],
    label: 'Компания туралы',
    title: 'Мемлекеттік қаржы',
    titleEm: 'экожүйесіндегі',
    titleEnd: 'жаңа рөлі',
    subtitle:
      '2025 жылы «Қаржы орталығы» АҚ стратегиялық даму кезеңіне кірді. Біз қаржы процестерінің қатысушысы ғана емес, мемлекеттік бағдарламаларды қаржыландырудың заманауи архитектурасын қалыптастыратын модельдер, деректер мен ережелердің интеграторы боламыз.',
    values: [
      { title: 'Жауапкершілік', text: 'Қаржыландыру - қоғамдық маңызды нәтижелерге жету құралы' },
      { title: 'Кәсіби тереңдік', text: 'Шешімдер деректер, есептеулер мен аналитикаға негізделеді' },
      { title: 'Интеграция', text: 'Нормативтік базаны, цифрлық шешімдер мен аналитиканы бір жүйеге біріктіреміз' },
    ],
  },
  pnf: {
    label: 'Жан басына шаққандағы нормативтік қаржыландыру',
    title: 'Білім беру',
    titleEm: 'жүйесін қаржыландыру',
    subtitle:
      '«Қаржы орталығы» АҚ барлық деңгейде мемлекеттік білім беру тапсырысын сүйемелдейді. Толық ақпарат үшін білім беру деңгейін таңдаңыз.',
    portalsStats: 'orta-bilim.e-qazyna.kz порталындағы статистика',
    summaryTitle: '2026 жылы барлық білім беру деңгейлерін қаржыландыру көлемі',
    tableHead: ['Білім беру деңгейі', 'Ұйымдар', 'Контингент', '2026 ж. мемлекеттік тапсырыс көлемі'],
    algoTitle: 'Жан басына шаққандағы нормативтік қаржыландыруды есептеу алгоритмі',
    keleshekTag: 'Бірыңғай ерікті жинақтау жүйесі',
    keleshekTitle: '«Келешек» - әр баланың болашағына кепілдік',
    keleshekDesc:
      'Жүйе ата-ананың негізгі міндеттемелерін орындауға мүмкіндік береді: балаға сапалы білім, лайықты мамандық және тұрғын үй мәселесін шешу. Негізгі алаң - Aqyl МББЖ.',
    keleshekFeatures: [
      'Мемлекеттен жыл сайынғы сыйақылар',
      'Сыйақы / инвестициялық табыс',
      'Депозиттер мен сақтандыруды кепілдендіру',
      'Өндіріп алудан қорғау',
      'Оқу орнын таңдауға шектеу жоқ',
      'Жас шектеулері жоқ',
    ],
    calcTitle: 'Жинақтау калькуляторы',
    calcLabels: {
      startCapital: 'Мемлекеттен бастапқы капитал',
      parentMRP: 'Ата-ананың жыл сайынғы жарнасы',
      premium: 'Мемлекеттік сыйақы',
      bank: 'Банк сыйақысы',
      years: 'Жинақтау мерзімі',
      calcBtn: 'Есептеу',
      result: 'Жинақтаудың жалпы сомасы',
    },
    summaryRows: [
      'Мектепке дейінгі білім',
      'Орта білім',
      'ТЖКБ (колледждер)',
      'ЖОКББ (ЖОО)',
      'Қосымша білім',
      'ЖОКББ/ТЖКБ стипендиялары',
    ],
    totalRow: 'БАРЛЫҒЫ',
    summaryMeta: [
      { orgs: '11 909 балабақша', contingent: '988 мың тәрбиеленуші', budget: '~924 млрд тг' },
      { orgs: '9 193 мектеп', contingent: '3 964 мың оқушы', budget: '~3,6 трлн тг' },
      { orgs: '763 колледж', contingent: '556 мың студент', budget: '~514 млрд тг' },
      { orgs: '123 ЖОО', contingent: '752 мың студент', budget: '~504 млрд тг' },
      { orgs: '3 674 ұйым', contingent: '1,15 млн оқушы', budget: '~154 млрд тг' },
      { orgs: '-', contingent: '240 мың стипендиат', budget: '~174 млрд тг' },
    ],
  },
  timeline: {
    label: 'Тарих',
    title: 'Тарих',
    titleEm: '«Қаржы орталығы» АҚ',
  },
  management: {
    label: 'Басшылық',
    title: 'Біздің',
    titleEm: 'команда',
    tabs: {
      board: 'Директорлар кеңесі',
      pravlenie: 'Басқарма',
      directors: 'Басшылық',
      structure: 'Ұйымдық құрылым',
    },
    structureCaption: '«Қаржы орталығы» АҚ ұйымдық құрылымы',
    structureHint: 'Үлкейту үшін басыңыз',
    structureOpen: 'Жаңа терезеде ашу',
    structureAria: 'Ұйымдық құрылымды ашу',
    chairBadge: 'Басқарма төрағасы',
    board: [
      { initials: 'СД', name: 'Рустем Куандыков', role: 'Директорлар кеңесінің төрағасы', tag: 'Директорлар кеңесі' },
      { initials: 'НД', name: 'Тәуелсіз директор', role: 'Аудит, тәуекелдер және қаржы', tag: 'Директорлар кеңесі' },
      { initials: 'НД', name: 'Тәуелсіз директор', role: 'Стратегия және даму', tag: 'Директорлар кеңесі' },
    ],
    pravlenie: [
      { initials: 'ПП', name: 'Басқарма төрағасы', role: 'Утельбаева Шолпан Ануарбекқызы', isChair: true },
      { initials: 'ЗП', name: 'Басқарма төрағасының бірінші орынбасары', role: 'Ерекешева Кенжегуль Капбасовна' },
      { initials: 'ЗП', name: 'Басқарма төрағасының орынбасары', role: 'Надирбеков Тимур Даулетулы' },
    ],
  },
  news: {
    badge: 'Өзекті',
    label: 'Жаңалықтар',
    title: 'Жаңалықтар',
    titleEm: 'және оқиғалар',
    allNews: 'Барлық жаңалықтар',
    readMore: 'Толығырақ',
    readArticle: 'Мақаланы оқу →',
    readShort: 'Оқу →',
    page: 'Бет',
  },
  faq: {
    label: 'FAQ',
    title: 'Жиі қойылатын сұрақтар',
    titleEm: 'және материалдар',
    subtitle:
      'Алдымен - жауаптар аккордеонда, төменде - иконкалар, жүктеу және жылдам алдын ала қарау бар «Презентациялар мен материалдар».',
    materialsTitle: 'Презентациялар мен материалдар',
    faqListAria: 'Жиі қойылатын сұрақтар',
    materialsAria: 'Презентациялар мен материалдар',
    preview: 'Алдын ала қарау',
    download: 'Жүктеу',
    extraFaq: [
      {
        q: 'Бағдарлама бойынша өтінімді қалай беруге немесе шарттарды қалай нақтылауға болады?',
        a: 'Бағдарламаға байланысты ведомство/ұйымның жеке кабинеті немесе уәкілетті операторлар арқылы беру қолжетімді. Алғашқы консультация үшін футердегі байланыстарды пайдаланыңыз және бағдарлама мен өңірді көрсетіңіз.',
      },
      {
        q: 'Нормативтер мен есептеу әдіснамасын қайдан көруге болады?',
        a: 'Нормативтік құжаттар материалдар бөлімінде және бағдарлама карточкаларында жарияланады. Соңғы редакцияны пайдаланып, бекіту күнін тексеру ұсынылады.',
      },
      {
        q: 'Қаражатты бөлудің ашықтығы қалай қамтамасыз етіледі?',
        a: 'Бірыңғай есептеу ережелері, алушылардың цифрлық тізілімдері, деректерді верификациялау және көрсеткіштерді мониторингілеу арқылы. Бұл қолмен шешімдер үлесін азайтады және параметрлер салыстырмалығын арттырады.',
      },
      {
        q: 'Басшылық үшін презентация/анықтама алуға бола ма?',
        a: 'Иә. Төменде материалдар тізімі (PDF) бар. Сіздің жағдайыңызға жаңарту үшін сұраныс қалдырыңыз - қысқа анықтама және қосымшаларды дайындаймыз.',
      },
    ],
    materials: [
      { title: 'Презентация: Қаржы орталығы (шолу)', meta: 'Жаңартылды: 2025 • 3.4 MB' },
      { title: 'Әдіснама: нормативтер мен коэффициенттер', meta: 'Редакция: 2025 • 1.9 MB' },
      { title: 'Есеп: бағдарламалар тиімділігін мониторингілеу', meta: 'Тоқсан: Q1 2025 • 4.8 MB' },
    ],
  },
  contacts: {
    label: 'Байланыс',
    title: 'Сұрақтар қалды ма?',
    titleEm: 'Бізге жазыңыз',
    subtitle: 'Өтінімді толтырыңыз, бір жұмыс күні ішінде хабарласамыз.',
    formTitle: 'Сұрақтар қалды ма?',
    formSubtitle: 'Өтінімді толтырыңыз, бір жұмыс күні ішінде хабарласамыз.',
    appealBtn: 'Азаматтар өтінімі',
    send: 'Жіберу',
    success: 'Рахмет! Өтініміңіз қабылданды.',
    chairman: {
      name: 'Утельбаева Шолпан Ануарбековна',
      role: 'Басқарма төрағасы',
    },
    address: 'Астана қ., 010000, Мәңгілік Ел даңғылы 18',
    hours: 'Дс-Жм: 09:00-18:00',
    phoneFree: '(тегін)',
    writeUs: 'Бізге жазу',
    openDialog: 'Ашық диалог',
    form: {
      nameLabel: 'Атыңыз *',
      phoneLabel: 'Телефон *',
      emailLabel: 'Email',
      messageLabel: 'Хабарлама',
      agreeLabel: 'Жеке деректерді өңдеуге келісім беремін',
      namePlaceholder: 'Иванов Иван',
      phonePlaceholder: '+7 (___) ___-__-__',
      emailPlaceholder: 'example@mail.kz',
      messagePlaceholder: 'Сұрағыңыз немесе пікіріңіз',
      errName: 'Атыңызды енгізіңіз',
      errPhone: 'Телефонды енгізіңіз',
      errAgree: 'Келісім қажет',
      thanksTitle: 'Рахмет!',
      thanksSub: 'Бір жұмыс күні ішінде хабарласамыз.',
    },
    appeal: {
      title: 'Өтінім беру',
      category: 'Өтінім санаты',
      description: 'Сипаттама',
      descPlaceholder: 'Сұрағыңыз',
      chars: 'таңба (минимум 25)',
      lastName: 'Тегі',
      firstName: 'Аты',
      patronymic: 'Әкесінің аты (бар болса)',
      patronymicShort: 'Әкесінің аты',
      submit: 'Өтінім беру',
      successTitle: 'Өтінім жіберілді!',
      successSub: 'Өтініміңізді қарастырып, сізбен хабарласамыз.',
    },
    categories: [
      'Студенттік жатақханаларды салу/реконструкциялау',
      'Салу/реконструкциялау',
      'Жан басына шаққандағы нормативтік қаржыландыру',
      '«Aqyl» депозиті',
      'Грантты өтеу',
      'Білім кредиттерін қайтару',
      'Стипендия есептеу',
      'Баспасөз қызметімен байланыс',
      'Басқа',
    ],
  },
  footer: {
    about:
      '«Қаржы орталығы» АҚ - мемлекеттік басқару дәстүрін заманауи цифрлық құралдармен ұштастыратын институт.',
    nav: 'Навигация',
    contacts: 'Байланыс',
    materials: 'Материалдар',
    copy: '© 2025 «Қаржы орталығы» АҚ. Барлық құқықтар қорғалған.',
    links: {
      news: 'Жаңалықтар',
      programs: 'Бағдарламалар',
      faq: 'FAQ',
      contacts: 'Байланыс',
      presentations: 'Презентациялар (PDF)',
      funding: 'Мемлекеттік бағдарламаларды қаржыландыру',
      history: 'Тарих',
    },
  },
  newRole: {
    badge: 'Трансформация',
    title: 'Білім беруді қаржыландыруды трансформациялау стратегиясы',
    subtitle:
      'Шығындық модельден адам капиталына инвестицияға өту: ашықтық, өлшенетіндік және бірыңғай цифрлық экожүйе.',
    goal: 'Мақсат',
    goalText:
      'Басқарылатын, өлшенетін және мақсатсыз шығындардан қорғалған қаржыландыру жүйесін құру.',
    vision: '2028 көзқарасы',
    visionText: 'Қазақстан білім беруін инвестициялық қаржыландыру моделін қалыптастыру.',
    pillarsTitle: '2028 жылғы инвестициялық модель',
    roadmapTitle: 'Трансформация жол картасы',
    ecosystemTitle: 'Цифрлық экожүйені бірыңғайландыру',
    before: 'Бұрын: 8 жүйеде фрагментация',
    after: 'Қазір: бірыңғай e-Qazyna.kz порталы',
    pillars: [
      { title: 'Data Hub', desc: 'Барлық білім беру деңгейлері бойынша бірыңғай аналитика, деректерді жинау және верификация.' },
      { title: 'Ашықтық', desc: 'Мақсатсыз шығындардан қорғалған, басқарылатын және өлшенетін қаржыландыру моделі.' },
      { title: 'Индекс', desc: 'Сапа, тұрақтылық және нәтижелілікті индикаторлық бағалау моделіне көшу.' },
      { title: 'Ваучер', desc: 'Қаржыландыру қызмет алушыға еріккен механизмдер.' },
      { title: 'Инвестициялар (KASE, DAMU)', desc: 'Жеке капиталды тарту және білім инвестициялары нарығын іске қосу.' },
      { title: 'Тиімділікті бағалау', desc: 'Аккредитация және басқарушылық нәтижелерді цифрда бағалау.' },
    ],
    roadmap: [
      { title: 'Толық цифрландыру (2026)', desc: 'Деректерді мемлекеттік тізілімге көшіру, білім ұйымдарының бірыңғай цифрлық базасы және ақпарат көздерін интеграциялау.' },
      { title: 'Деректер картасы (2026)', desc: 'Аналитикалық жүйе құру, деректерді тоқсан сайын жинау және талдау, аналитикалық дашбордтарды іске қосу.' },
      { title: 'ЖБШ әдіснамасын қайта қарау (2026-2027)', desc: 'Тарифтер мен нормативтерді ревизиялау, нормалар мен есептеу әдіснамасын жаңарту, модельдерді цифрландыру.' },
      { title: 'Индикаторлық модель (2027)', desc: 'Ұйымдар сапасы, тұрақтылығы мен нәтижелілігінің өлшенетін көрсеткіштеріне негізделген басқару.' },
      { title: 'Білімді токенизациялау (2028)', desc: 'Білім беру нәтижелерін цифрландыру және нәтижеге негізделген қаржыландыруға көшу.' },
      { title: 'Облигация ретіндегі токенизация (2028)', desc: 'Инвестициялық токендерді (облигациялар) шығару, жеке капиталды тарту және инвестиция нарығын қалыптастыру.' },
    ],
    beforeSystems: ['LMS', 'УМОСК', 'ЭГЗ', 'ИСГП', 'НОБД', 'ЭСФ', 'ИС БВУ', 'ИСКК'],
    afterSystems: ['Лицензиялар / рұқсат құжаттары', 'Өтінімдер', 'Бюджет', 'Шарттар'],
  },
  workingOff: {
    label: 'Студенттерге',
    title: 'Мемлекеттік білім беру гранттарын өтеу',
    subtitle: 'Ақпаратты сайтта ашу үшін қажетті бөлімді таңдаңыз.',
  },
  investors: {
    label: 'Инвесторларға',
    title: 'Инвестициялық',
    titleEm: 'жобалар',
    tabs: ['Жоба шарттары', 'Нормативтер', 'Орналастыру алгоритмі', 'Қолдау'],
    ...investorsContentKz,
  },
  a11y: {
    panel: 'Әлсіз көретіндерге арналған нұсқа параметрлері',
    exit: 'Қарапайым нұсқа',
    font: 'Қаріп',
    fontGroup: 'Қаріп өлшемі',
    decreaseFont: 'Қаріпті кішірейту',
    resetFont: 'Қаріп өлшемін қалпына келтіру',
    increaseFont: 'Қаріпті үлкейту',
    visionToggle: 'Әлсіз көретіндерге арналған нұсқа',
  },
  hero: { scroll: 'Төмен' },
};
